import PropTypes from "prop-types";
import ReportHeader from "./ReportHeader";
import { TR } from "./BusinessDashboard/Table/Table";

const AgentCallsHeaders = ({ sortBy, sortKey, sortDesc }) => (
  <TR className="tw-bg-white tw-sticky tw-top-0">
    <ReportHeader name="agent" sortDesc={sortDesc} sortKey={sortKey} label="Name" handleSort={sortBy} />
    <ReportHeader
      name="call_report_agent_total_lead_count"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Total Leads"
      tooltipDesc="Contacts assigned to the agent during this date range, including contacts in ponds the agent is the display agent for. Excludes archived and trashed contacts and contacts without an email or phone number."
      handleSort={sortBy}
    />
    <ReportHeader
      name="call_report_lead_call_count"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Leads Called"
      tooltipDesc="Unique contacts the agent called during this date range, whether or not the call connected"
      handleSort={sortBy}
    />
    <ReportHeader
      name="call_report_manual_calls"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Manual"
      tooltipDesc="Calls that were not made through Brivity but were manually logged into the CRM"
      handleSort={sortBy}
    />
    <ReportHeader
      name="call_report_dialer_calls"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Dialer"
      tooltipDesc="Number of calls made through Brivity’s dialer tool"
      handleSort={sortBy}
    />
    <ReportHeader
      name="call_report_total_calls"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Total Calls"
      tooltipDesc="Overall number of calls made, combining both manual and dialer calls"
      handleSort={sortBy}
    />
    <ReportHeader
      name="call_report_total_dialer_call_time_seconds"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Total Call Time"
      tooltipDesc="Cumulative duration of all calls made"
      handleSort={sortBy}
    />
  </TR>
);

AgentCallsHeaders.propTypes = {
  sortBy: PropTypes.func.isRequired,
  sortKey: PropTypes.string.isRequired,
  sortDesc: PropTypes.bool.isRequired,
};

export default AgentCallsHeaders;
